// 燃气费缴费——微信，主流程
const wxMainRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `gas/wx/index${i + 1}`,
  name: `gasWxIndex${i + 1}`,
  component: () => import(`@/views/life/gas/wx/index${i + 1}.vue`)
}))

// 燃气费缴费——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `gas/zfb/index${i + 1}`,
  name: `gasZfbIndex${i + 1}`,
  component: () => import(`@/views/life/gas/zfb/index${i + 1}.vue`),
}));

// 燃气费缴费——支付宝，分支1
const zfbBranch1Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `gas/zfb/branch1/index${i + 1}`,
  name: `gasZfbBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/life/gas/zfb/branch1/index${i + 1}.vue`),
}));

export default {
  path: '/life',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 燃气费缴费——微信，开始
    ...wxMainRoutes,

    // 燃气费缴费——支付宝，主流程
    ...zfbMainRoutes,
    // 燃气费缴费——支付宝，分支1
    ...zfbBranch1Routes


  ]
}
